import React from 'react'

const React_Coding_Practice_19 = () => {
  return (
    <div>
      <h1>Coding Pratice 19</h1>
    </div>
  )
}

export default React_Coding_Practice_19
